__turbopack_context__.v({
  "className": "inter_78359438-module__-Qgr4W__className",
  "variable": "inter_78359438-module__-Qgr4W__variable",
});
